module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon5b.06c128d3.png";